import { Component, Input } from '@angular/core';

@Component({
  template: ` <ion-item lines="none" *transloco="let t">
    <ion-col size="12">
      <ion-row>
        <ion-col size="8"> {{ t(pageType + '.' + title) }}:</ion-col>
        <ion-col size="4" float-right>{{ value }}</ion-col>
      </ion-row>
    </ion-col>
  </ion-item>`,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'insights-details-section',
})
export class InsightsDetailsSectionComponent {
  @Input() title: string;
  @Input() value: string | number;
  @Input() pageType: string;

  constructor() {}

}
